export const $ = (id) => document.getElementById(id);
export const $1 = (selector) => document.querySelector(selector);
export const $$ = (selector) => document.querySelectorAll(selector);

export const $e = (tagName, { style, ...props } = {}, ...children) => {
  const e = document.createElement(tagName);
  Object.assign(e, props);
  Object.assign(e.style, style);
  e.append(...children);
  return e;
};

export const tap = (obj, ...cbs) => (obj && cbs.forEach((cb) => cb(obj)), obj);
